<template>
  <div class="ContactUs">
    <div class="pipedriveWebForms" data-pd-webforms="https://webforms.pipedrive.com/f/ctqF0NV5lm2Sys1aRRe4PELLAHtZBZLH62V8lxDAEIoPvnmVH3aox4MAd1darg7lIf"></div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  mounted() {
    let formScript = document.createElement('script')
    formScript.setAttribute('src', 'https://webforms.pipedrive.com/f/loader')
    document.head.appendChild(formScript)
  }
}
</script>

<style lang="scss">
.ContactUs {
 padding: 100px 10px;
  @media screen and (max-width: 810px) {
    margin-top: calc(20px + #{$header-width});
    margin-bottom: 200px;
  }
}
</style>
